import React, { useEffect, useState, useMemo } from "react";
import {/* Alert, Row, Col, Form, Button,*/ UncontrolledTooltip } from "reactstrap";
import { createSelector } from "reselect";
// router
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";

// hooks
import { useRedux } from "../hooks/index";
import { authRegisterApiResponseError } from "../redux/auth/register/actions"
import { AuthRegisterActionTypes } from "../redux/auth/register/types"

import imgSms from "../assets/images/icon/mobile_sms.png";
import imgSmsFake from "../assets/images/icon/mobile_sms_fake.png";

// config
import config from "../config";
import { Utils } from "helpers/utils";

const errorData = createSelector(
    (state: any) => state.Register,
    (state: any) => state.Profile2,
    (state, pf2) => ({
        user: state.user,
        registrationError: state.registrationError,
        regLoading: state.loading,
        isUserRegistered: state.isUserRegistered,
        isFakeSms : pf2.isFakeSms,

    })
);


interface LoginButtonProps {
    // onClick: () => void;
    type: string; /*line, mobile*/
    mode: string; /*login,register*/
}

const LoginButton = ({ type, mode }: LoginButtonProps) => {
    const { dispatch, useAppSelector } = useRedux();
    const { user, registrationError, regLoading, isFakeSms } = useAppSelector(errorData);
    const navigate = useNavigate();
    const location = useLocation();

    const isLine = type == "line";
    const isMobile = type == "mobile";
    const isLogin = mode == "login";
    const isRegister = mode == "register";

    const setError = (errorMsg: string) => {
        dispatch(authRegisterApiResponseError(AuthRegisterActionTypes.REGISTER_USER, errorMsg));
    }
    const setInfo = (errorMsg: string) => {
        dispatch(authRegisterApiResponseError(AuthRegisterActionTypes.REGISTER_USER, errorMsg));
    }

    useEffect(() => {
        // get query string
        const queryParms = new URLSearchParams(location.search);
        const qError = queryParms.get("error");
        const qInfo = queryParms.get("info");
        if (qError) setError(qError);
        else if (qInfo) setInfo(qInfo);
    }, [location]);

    const id = `btnLogin_${type}`;
    const icon = () => {
        if (isLine) return "mdi mdi-line text-success";
        if (isMobile) return "mdi mdi-cellphone text-dark";
        return "";
    };

    const img = useMemo(() => {
        //console.log("[isLine, isMobile, isFakeSms]", {isLine, isMobile, isFakeSms});
        if (isLine) return "https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/LINE_logo.svg/320px-LINE_logo.svg.png?20220419085336";
        if (isMobile) {
            if (isFakeSms == "True"){
                return imgSmsFake;
            }
            if (isFakeSms == "False" || !isFakeSms || isFakeSms == null || isFakeSms === undefined){
                return imgSms;
            }else{
                return imgSmsFake;
            }
        }
        return "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSKsZNFiDl8HcHOVO7S-1IDxHrUXOUxPsL_rEEZH0SM5bjY5D8OpkyIKFM2wO3lZCLRmsA&usqp=CAU";
    },[isLine, isMobile, isFakeSms]);

    const tooltip = () => {
        let capType = isLine ? "บัญชีไลน์" : "เบอร์มือถือ และยืนยันด้วยรหัส OTP";
        let capMode = isLogin ? "ล็อกอิน" : "ลงทะเบียน";
        return capMode + " " + capType;
    }

    const onClick = () => {
        let sel_user_type = document.getElementById('sel_user_type') as HTMLSelectElement;
        let user_type_val = '';
        if (sel_user_type) {
            if (!sel_user_type.value) {
                setError("Please choose who you are?");
                return false;
            } else {
                user_type_val = sel_user_type.value;
            }
        }

        if (isLine) {
            const channelId = config.LINE.CHANNEL_ID;
            const callbackUrl = config.LINE.CALLBACK;
            const state = (isLogin ? "login_" : "register_") + user_type_val;
            const lineLoginUrl = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${channelId}&redirect_uri=${callbackUrl}&state=${state}&scope=openid%20profile`;

            window.location.href = lineLoginUrl; // redirect to LINE authentication page.
            //window.open(lineLoginUrl, '_self');
            return false;
        } else {
            navigate("/auth-register-phone?login=1");
            return false;
        }

    }

    return (
        <div>
            <div>
                <button
                    type="button"
                    className="btn btn-light w-100"
                    onClick={() => { return onClick() }}
                    id={id}
                >
                    {/* <i className={icon()}></i> */}
                    <img src={img} style={{ height: '40px', width: '40px' }} ></img>
                </button>
            </div>
            {/* <UncontrolledTooltip placement="top" target={id}>{tooltip()}</UncontrolledTooltip> */}
        </div>

    );
};

export default LoginButton;
